export const urlConstants = {
    TWITTER_URL: 'https://www.twitter.com',
    FACEBOOK_URL: 'https://www.facebook.com/profile.php?id=100073720227499',
    INSTAGRAM_URL: 'https://www.instagram.com/freshlinenlaunders/',
    ANNA_NAGAR_PHONE_NUMBER: 'tel:(+91) 917 640 4433',
    VELACHERY_PHONE_NUMBER: 'tel:(+91) 917 640 2233',
    PHONE_TEXT: 'Call (+91) 917 640 2233',
    VELACHERY_WHATSAPP_URL: 'https://wa.me/919176402233',
    ANNA_NAGAR_WHATSAPP_URL: 'https://wa.me/919176404433'
}